import React from 'react';
import PropTypes from 'prop-types';

function EyeOff({ size, stroke = 'currentColor', strokeWidth, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...otherProps}
    >
      <path
        d="M8.95251 5.28466C9.88552 4.93679 10.9029 4.72729 12 4.72729C17.1858 4.72729 20.5887 9.40765 21.7319 11.2591C21.8703 11.4831 21.9395 11.5951 21.9782 11.7679C22.0073 11.8977 22.0073 12.1024 21.9782 12.2321C21.9395 12.4049 21.8703 12.5169 21.7319 12.741C21.2851 13.4647 20.4929 14.6207 19.3839 15.7604M9.57927 10.1063C9.18612 10.6312 8.95251 11.2877 8.95251 12C8.95251 13.7214 10.3169 15.1169 12 15.1169C12.7202 15.1169 13.382 14.8614 13.9036 14.4342M17 17.7308C15.5935 18.632 13.9188 19.2727 12 19.2727C6.81418 19.2727 3.41127 14.5924 2.26805 12.741C2.12971 12.5169 2.06054 12.4049 2.02181 12.2321C1.99273 12.1024 1.99273 11.8977 2.02181 11.7679C2.06054 11.5951 2.12971 11.4831 2.26805 11.2591C2.90198 10.2324 4.23072 8.33596 6.17298 6.84999"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.81818 3.81818L20.1818 20.1818"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

EyeOff.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default EyeOff;
